export default __webpack_public_path__ + "static/media/280.0fbd6ad2.jpg";